import {BorderArticle} from "@ui/general/BorderArticle";
import {PreviewCard} from "@ui/general/PreviewCard";
import {H3} from "@ui/titles/H3";

import styles from "./styles.module.scss";

export const SimulationsLayout = ({
  isBig = false,
  levelList,
  cards,
  title,
  background = "var(--white)",
  useAnamChat = false,
  footerBannerSrc = null,
  footerBannerAlt = "",
  footerBannerAbsoluteFill = false,
}) => {
  const hasFlowBanner = Boolean(footerBannerSrc) && !footerBannerAbsoluteFill;

  const inner = (
    <>
      <H3>{title}</H3>

      <ul className={styles.simulationsList}>
        {cards &&
          cards.map((item) => (
            <li key={item?.id}>
              <PreviewCard
                certified={item?.certified}
                isBig={isBig}
                due_date={item?.due_date}
                finish_date={item?.finish_date}
                start_date={item?.start_date}
                levelList={levelList}
                name={item?.name}
                image={item?.cover}
                until={item?.until}
                mask={item?.mask}
                id={item?.id}
                avatar_type={item?.avatar_type}
                mandatory={item?.mandatory}
                useAnamChat={useAnamChat}
                // trainingLimit={item?.certification?.training_limit}
              />
            </li>
          ))}
      </ul>

      {hasFlowBanner ? (
        <img
          src={footerBannerSrc}
          alt={footerBannerAlt}
          className={styles.footerBanner}
        />
      ) : null}
    </>
  );

  return (
    <div className={"container-big phone:p-0"}>
      <div className={styles.simulationsWrapper}>
        <BorderArticle>
          <div
            className={
              footerBannerAbsoluteFill && footerBannerSrc
                ? `${styles.simulations} ${styles.simulationsWithAbsoluteBanner}`
                : styles.simulations
            }
            style={{background}}
          >
            {footerBannerAbsoluteFill && footerBannerSrc ? (
              <img
                src={footerBannerSrc}
                alt={footerBannerAlt}
                className={styles.footerBannerAbsolute}
              />
            ) : null}

            {footerBannerAbsoluteFill ? (
              <div className={styles.simulationsBodyAboveBanner}>{inner}</div>
            ) : (
              inner
            )}
          </div>
        </BorderArticle>
      </div>
    </div>
  );
};
